import React from "react";

type ResourceIconsNames = "crown" | "people" | "container" | "truck" | "user" | "clipboard-text";

export interface ResourceIconsProps {
  name: ResourceIconsNames;
  size?: number;
  width?: number;
  height?: number;
}

export const ResourceIcons: React.FC<ResourceIconsProps> = (props) => {
  const { name, size = 20 } = props;

  if (name === "crown")
    return (
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
      >
        <g id="Outlined/crown">
          <path
            id="icon"
            d="M17 21.04H7C3.83 21.04 1.25 18.46 1.25 15.29V5.70998C1.25 4.40998 1.85 3.95998 2.21 3.80998C2.57 3.65998 3.31 3.54998 4.23 4.46998L6.82 7.05998C6.92 7.15998 7.08 7.15998 7.17 7.05998L10.76 3.46998C11.42 2.80998 12.58 2.80998 13.23 3.46998L16.82 7.05998C16.92 7.15998 17.08 7.15998 17.17 7.05998L19.76 4.46998C20.68 3.54998 21.42 3.66998 21.78 3.80998C22.14 3.95998 22.74 4.39998 22.74 5.70998V15.3C22.75 18.73 20.44 21.04 17 21.04ZM2.81 5.23998C2.78 5.31998 2.75 5.46998 2.75 5.70998V15.3C2.75 17.64 4.66 19.55 7 19.55H17C19.58 19.55 21.25 17.88 21.25 15.3V5.70998C21.25 5.46998 21.22 5.32998 21.19 5.24998C21.11 5.28998 20.99 5.36998 20.82 5.53998L18.23 8.12998C17.57 8.78998 16.41 8.78998 15.76 8.12998L12.17 4.53998C12.07 4.43998 11.91 4.43998 11.82 4.53998L8.24 8.11998C7.58 8.77998 6.42 8.77998 5.77 8.11998L3.18 5.52998C3.01 5.35998 2.88 5.27998 2.81 5.23998Z"
            fill="currentColor"
          />
        </g>
      </svg>
    );

  if (name === "people") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/people">
          <g id="icon">
            <path
              d="M17.9998 7.91002C17.9698 7.91002 17.9498 7.91002 17.9198 7.91002H17.8698C15.9798 7.85002 14.5698 6.39001 14.5698 4.59001C14.5698 2.75001 16.0698 1.26001 17.8998 1.26001C19.7298 1.26001 21.2298 2.76001 21.2298 4.59001C21.2198 6.40001 19.8098 7.86001 18.0098 7.92001C18.0098 7.91001 18.0098 7.91002 17.9998 7.91002ZM17.8998 2.75002C16.8898 2.75002 16.0698 3.57002 16.0698 4.58002C16.0698 5.57002 16.8398 6.37002 17.8298 6.41002C17.8398 6.40002 17.9198 6.40002 18.0098 6.41002C18.9798 6.36002 19.7298 5.56002 19.7398 4.58002C19.7398 3.57002 18.9198 2.75002 17.8998 2.75002Z"
              fill="currentColor"
            />
            <path
              d="M18.01 15.28C17.62 15.28 17.23 15.25 16.84 15.18C16.43 15.11 16.16 14.72 16.23 14.31C16.3 13.9 16.69 13.63 17.1 13.7C18.33 13.91 19.63 13.68 20.5 13.1C20.97 12.79 21.22 12.4 21.22 12.01C21.22 11.62 20.96 11.24 20.5 10.93C19.63 10.35 18.31 10.12 17.07 10.34C16.66 10.42 16.27 10.14 16.2 9.73002C16.13 9.32002 16.4 8.93003 16.81 8.86003C18.44 8.57003 20.13 8.88002 21.33 9.68002C22.21 10.27 22.72 11.11 22.72 12.01C22.72 12.9 22.22 13.75 21.33 14.35C20.42 14.95 19.24 15.28 18.01 15.28Z"
              fill="currentColor"
            />
            <path
              d="M5.96998 7.91C5.95998 7.91 5.94998 7.91 5.94998 7.91C4.14998 7.85 2.73998 6.39 2.72998 4.59C2.72998 2.75 4.22998 1.25 6.05998 1.25C7.88998 1.25 9.38998 2.75 9.38998 4.58C9.38998 6.39 7.97998 7.85 6.17998 7.91L5.96998 7.16L6.03998 7.91C6.01998 7.91 5.98998 7.91 5.96998 7.91ZM6.06998 6.41C6.12998 6.41 6.17998 6.41 6.23998 6.42C7.12998 6.38 7.90998 5.58 7.90998 4.59C7.90998 3.58 7.08998 2.75999 6.07998 2.75999C5.06998 2.75999 4.24998 3.58 4.24998 4.59C4.24998 5.57 5.00998 6.36 5.97998 6.42C5.98998 6.41 6.02998 6.41 6.06998 6.41Z"
              fill="currentColor"
            />
            <path
              d="M5.96 15.28C4.73 15.28 3.55 14.95 2.64 14.35C1.76 13.76 1.25 12.91 1.25 12.01C1.25 11.12 1.76 10.27 2.64 9.68002C3.84 8.88002 5.53 8.57003 7.16 8.86003C7.57 8.93003 7.84 9.32002 7.77 9.73002C7.7 10.14 7.31 10.42 6.9 10.34C5.66 10.12 4.35 10.35 3.47 10.93C3 11.24 2.75 11.62 2.75 12.01C2.75 12.4 3.01 12.79 3.47 13.1C4.34 13.68 5.64 13.91 6.87 13.7C7.28 13.63 7.67 13.91 7.74 14.31C7.81 14.72 7.54 15.11 7.13 15.18C6.74 15.25 6.35 15.28 5.96 15.28Z"
              fill="currentColor"
            />
            <path
              d="M11.9998 15.38C11.9698 15.38 11.9498 15.38 11.9198 15.38H11.8698C9.97982 15.32 8.56982 13.86 8.56982 12.06C8.56982 10.22 10.0698 8.72998 11.8998 8.72998C13.7298 8.72998 15.2298 10.23 15.2298 12.06C15.2198 13.87 13.8098 15.33 12.0098 15.39C12.0098 15.38 12.0098 15.38 11.9998 15.38ZM11.8998 10.22C10.8898 10.22 10.0698 11.04 10.0698 12.05C10.0698 13.04 10.8398 13.84 11.8298 13.88C11.8398 13.87 11.9198 13.87 12.0098 13.88C12.9798 13.83 13.7298 13.03 13.7398 12.05C13.7398 11.05 12.9198 10.22 11.8998 10.22Z"
              fill="currentColor"
            />
            <path
              d="M11.9998 22.76C10.7998 22.76 9.59978 22.45 8.66978 21.82C7.78978 21.23 7.27979 20.39 7.27979 19.49C7.27979 18.6 7.77978 17.74 8.66978 17.15C10.5398 15.91 13.4698 15.91 15.3298 17.15C16.2098 17.74 16.7198 18.58 16.7198 19.48C16.7198 20.37 16.2198 21.23 15.3298 21.82C14.3998 22.44 13.1998 22.76 11.9998 22.76ZM9.49979 18.41C9.02979 18.72 8.77979 19.11 8.77979 19.5C8.77979 19.89 9.03979 20.27 9.49979 20.58C10.8498 21.49 13.1398 21.49 14.4898 20.58C14.9598 20.27 15.2098 19.88 15.2098 19.49C15.2098 19.1 14.9498 18.72 14.4898 18.41C13.1498 17.5 10.8598 17.51 9.49979 18.41Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (name === "container") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/container">
          <g id="Vector">
            <path
              d="M10.9619 13.5052C10.8495 13.5052 10.737 13.4792 10.6332 13.4187L2.99481 8.99827C2.69204 8.81661 2.57958 8.41868 2.76125 8.10727C2.94291 7.79585 3.34083 7.69204 3.65225 7.8737L10.9619 12.1038L20.3045 6.81834C20.6159 6.63668 21.0138 6.74914 21.1955 7.0519C21.3772 7.36332 21.2647 7.76125 20.9619 7.94291L11.2993 13.4187C11.1869 13.4706 11.0744 13.5052 10.9619 13.5052Z"
              fill="currentColor"
            />
            <path
              d="M10.9619 21.3426C10.6073 21.3426 10.3131 21.0484 10.3131 20.6938V12.8478C10.3131 12.4931 10.6073 12.199 10.9619 12.199C11.3166 12.199 11.6107 12.4931 11.6107 12.8478V20.6938C11.6107 21.0484 11.3166 21.3426 10.9619 21.3426Z"
              fill="currentColor"
            />
            <path
              d="M10.9619 21.6799C10.2007 21.6799 9.4481 21.5156 8.85121 21.1868L4.23183 18.6176C2.97751 17.9256 2 16.2561 2 14.8201V9.93253C2 8.49654 2.97751 6.83564 4.23183 6.13495L10.9273 2.49308C12.1125 1.83564 13.9637 1.83564 15.1488 2.49308L19.7682 5.06228C21.0225 5.75433 22 7.42388 22 8.85986V13.7474C22 15.1834 21.0225 16.8443 19.7682 17.545L13.0727 21.1868C12.4758 21.5156 11.7232 21.6799 10.9619 21.6799ZM13.0381 3.29758C12.4931 3.29758 11.9567 3.41003 11.5588 3.6263L4.86332 7.27682C4.03287 7.73529 3.29758 8.98097 3.29758 9.93253V14.8201C3.29758 15.7716 4.03287 17.0173 4.86332 17.4844L9.4827 20.0536C10.2699 20.4948 11.654 20.4948 12.4412 20.0536L19.1367 16.4031C19.9671 15.936 20.7024 14.699 20.7024 13.7388V8.85121C20.7024 7.89965 19.9671 6.65398 19.1367 6.18685L14.5173 3.61765C14.1194 3.41003 13.583 3.29758 13.0381 3.29758Z"
              fill="currentColor"
            />
            <path
              d="M13.7647 18.782C13.5225 18.782 13.3322 18.5917 13.3322 18.3495V13.5052C13.3322 13.263 13.5225 13.0727 13.7647 13.0727C14.0069 13.0727 14.1972 13.263 14.1972 13.5052V18.3495C14.1972 18.5917 14.0069 18.782 13.7647 18.782Z"
              fill="currentColor"
            />
            <path
              d="M16.4031 17.1211C16.1609 17.1211 15.9706 16.9308 15.9706 16.6886V11.8356C15.9706 11.5934 16.1609 11.4031 16.4031 11.4031C16.6453 11.4031 16.8356 11.5934 16.8356 11.8356V16.6886C16.8356 16.9308 16.6453 17.1211 16.4031 17.1211Z"
              fill="currentColor"
            />
            <path
              d="M19.0329 15.6246C18.7907 15.6246 18.6003 15.4343 18.6003 15.192V10.3478C18.6003 10.1055 18.7907 9.91522 19.0329 9.91522C19.2751 9.91522 19.4654 10.1055 19.4654 10.3478V15.192C19.4654 15.4343 19.2751 15.6246 19.0329 15.6246Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (name === "truck") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/truck">
          <g id="icon">
            <path
              d="M13 14.75H2C1.59 14.75 1.25 14.41 1.25 14V6C1.25 3.38 3.38 1.25 6 1.25H15C15.41 1.25 15.75 1.59 15.75 2V12C15.75 13.52 14.52 14.75 13 14.75ZM2.75 13.25H13C13.69 13.25 14.25 12.69 14.25 12V2.75H6C4.21 2.75 2.75 4.21 2.75 6V13.25Z"
              fill="currentColor"
            />
            <path
              d="M19 20.75H18C17.59 20.75 17.25 20.41 17.25 20C17.25 19.31 16.69 18.75 16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.41 14.41 20.75 14 20.75H10C9.59 20.75 9.25 20.41 9.25 20C9.25 19.31 8.69 18.75 8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.41 6.41 20.75 6 20.75H5C2.93 20.75 1.25 19.07 1.25 17V14C1.25 13.59 1.59 13.25 2 13.25H13C13.69 13.25 14.25 12.69 14.25 12V5C14.25 4.59 14.59 4.25 15 4.25H16.84C17.83 4.25 18.74 4.78001 19.23 5.64001L20.94 8.63C21.07 8.86 21.07 9.15 20.94 9.38C20.81 9.61 20.56 9.75 20.29 9.75H19C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H22C22.41 13.25 22.75 13.59 22.75 14V17C22.75 19.07 21.07 20.75 19 20.75ZM18.65 19.25H19C20.24 19.25 21.25 18.24 21.25 17V14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.03 8.25 19 8.25L17.93 6.38C17.71 5.99001 17.29 5.75 16.84 5.75H15.75V12C15.75 13.52 14.52 14.75 13 14.75H2.75V17C2.75 18.24 3.76 19.25 5 19.25H5.35001C5.68001 18.1 6.74 17.25 8 17.25C9.26 17.25 10.32 18.1 10.65 19.25H13.36C13.69 18.1 14.75 17.25 16.01 17.25C17.27 17.25 18.32 18.1 18.65 19.25Z"
              fill="currentColor"
            />
            <path
              d="M8 22.75C6.48 22.75 5.25 21.52 5.25 20C5.25 18.48 6.48 17.25 8 17.25C9.52 17.25 10.75 18.48 10.75 20C10.75 21.52 9.52 22.75 8 22.75ZM8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.69 7.31 21.25 8 21.25C8.69 21.25 9.25 20.69 9.25 20C9.25 19.31 8.69 18.75 8 18.75Z"
              fill="currentColor"
            />
            <path
              d="M16 22.75C14.48 22.75 13.25 21.52 13.25 20C13.25 18.48 14.48 17.25 16 17.25C17.52 17.25 18.75 18.48 18.75 20C18.75 21.52 17.52 22.75 16 22.75ZM16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.69 15.31 21.25 16 21.25C16.69 21.25 17.25 20.69 17.25 20C17.25 19.31 16.69 18.75 16 18.75Z"
              fill="currentColor"
            />
            <path
              d="M22 14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.04 8.25 19 8.25H20.29C20.56 8.25 20.81 8.39001 20.94 8.63L22.65 11.63C22.71 11.74 22.75 11.87 22.75 12V14C22.75 14.41 22.41 14.75 22 14.75ZM19 9.75C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H21.25V12.2L19.85 9.75H19Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (name === "user") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/user">
          <g id="icon">
            <path
              d="M12 12.75C8.83 12.75 6.25 10.17 6.25 7C6.25 3.83 8.83 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 10.17 15.17 12.75 12 12.75ZM12 2.75C9.66 2.75 7.75 4.66 7.75 7C7.75 9.34 9.66 11.25 12 11.25C14.34 11.25 16.25 9.34 16.25 7C16.25 4.66 14.34 2.75 12 2.75Z"
              fill="currentColor"
            />
            <path
              d="M20.5901 22.75C20.1801 22.75 19.8401 22.41 19.8401 22C19.8401 18.55 16.3202 15.75 12.0002 15.75C7.68015 15.75 4.16016 18.55 4.16016 22C4.16016 22.41 3.82016 22.75 3.41016 22.75C3.00016 22.75 2.66016 22.41 2.66016 22C2.66016 17.73 6.85015 14.25 12.0002 14.25C17.1502 14.25 21.3401 17.73 21.3401 22C21.3401 22.41 21.0001 22.75 20.5901 22.75Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    );
  }

  if (name === "clipboard-text") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          d="M15 12.95H8C7.59 12.95 7.25 12.61 7.25 12.2C7.25 11.79 7.59 11.45 8 11.45H15C15.41 11.45 15.75 11.79 15.75 12.2C15.75 12.61 15.41 12.95 15 12.95Z"
          fill="currentColor"
        />
        <path
          d="M12.38 16.95H8C7.59 16.95 7.25 16.61 7.25 16.2C7.25 15.79 7.59 15.45 8 15.45H12.38C12.79 15.45 13.13 15.79 13.13 16.2C13.13 16.61 12.79 16.95 12.38 16.95Z"
          fill="currentColor"
        />
        <path
          d="M14 6.75H10C9.04 6.75 7.25 6.75 7.25 4C7.25 1.25 9.04 1.25 10 1.25H14C14.96 1.25 16.75 1.25 16.75 4C16.75 4.96 16.75 6.75 14 6.75ZM10 2.75C9.01 2.75 8.75 2.75 8.75 4C8.75 5.25 9.01 5.25 10 5.25H14C15.25 5.25 15.25 4.99 15.25 4C15.25 2.75 14.99 2.75 14 2.75H10Z"
          fill="currentColor"
        />
        <path
          d="M15 22.75H9C3.38 22.75 2.25 20.17 2.25 16V10C2.25 5.44 3.9 3.49 7.96 3.28C8.36 3.26 8.73 3.57 8.75 3.99C8.77 4.41 8.45 4.75 8.04 4.77C5.2 4.93 3.75 5.78 3.75 10V16C3.75 19.7 4.48 21.25 9 21.25H15C19.52 21.25 20.25 19.7 20.25 16V10C20.25 5.78 18.8 4.93 15.96 4.77C15.55 4.75 15.23 4.39 15.25 3.98C15.27 3.57 15.63 3.25 16.04 3.27C20.1 3.49 21.75 5.44 21.75 9.99V15.99C21.75 20.17 20.62 22.75 15 22.75Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return <></>;
};
